import type { CommandFactory } from './types'

export const webSearchCommand: CommandFactory = (context) => ({
  id: 'web-search',
  name: 'web-search',
  description: 'Toggle web search on/off',
  aliases: ['websearch', 'web'],
  acceptsArgs: false,
  handler: async () => {
    context.onWebSearchToggle?.()
  },
})
